import { render, staticRenderFns } from "./RealEcharts.vue?vue&type=template&id=f496ed96&"
import script from "./RealEcharts.vue?vue&type=script&lang=js&"
export * from "./RealEcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports